import { Component, inject, OnInit } from '@angular/core';
import { BaseComponent } from '@app/core/bases';
import { Brand, BrandCollection } from '@app/core/interfaces';
import { ConfirmationService, FilterMetadata, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs';
import { MarqueForm } from '../marque-form/marque-form';
import { BrandService } from '@app/core/services';
import { CommonModule } from '@angular/common';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-marque-list',
  imports: [
    CommonModule,
    TableModule,
    CardModule,
    MultiSelectModule,
    FormsModule,
    ButtonModule,
    MenuModule,
    RippleModule,
    ConfirmDialogModule,
    ToastModule
  ],
  providers: [
    ConfirmationService,
    DialogService,
    MessageService,
  ],
  templateUrl: './marque-list.html'
})
export class MarqueList extends BaseComponent implements OnInit {
  brandService: BrandService = inject(BrandService)
  brands: Brand[] = [];
  selectedBrands!: Brand[];
  selectedBrand!: Brand | null;

  resultsLength = 0;
  pageIndex = 0;
  pageSize = 20;
  sort!: { field: string, order: number };
  filters: { [x: string]: any } = {};
  cols: Column[] = [{ field: 'nom', header: 'Nom' }];
  selectedColumns: Column[] = this.cols;

  isLoadingResults = true;

  constructor(
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
  ) {
    super();
  }

  ngOnInit(): void {
    const action = this.route.snapshot.fragment
    if (action && action == 'add') {
      this.location.replaceState(this.location.path(false))
      this.showModal()
    }
  } 

  showModal(brand?: Partial<Brand>): void {
    if (!brand) {
      brand = { nom: '' };
    }
    this.dialogRef = this.dialogService.open(MarqueForm, {
      inputValues: { brand: {...brand} },
      width: '450px',
      modal: true,
      header: `${brand.id ? 'Modification ' : 'Création '} d'une marque`
    });

    this.dialogRef?.onClose.subscribe((data: Brand | null) => {
      if (data) {
        this.getTableEntries();
      }
    });
  }

  getTableEntries() {
    this.isLoadingResults = true;
    this.apiCall$?.unsubscribe();
    this.apiCall$ = this.brandService
      .getCollection({order_by: this.sort.field, order: this.sort.order === 1 ? 'asc' : 'desc', size: this.pageSize, page: this.pageIndex + 1, ...this.filters})
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (collection: BrandCollection) => {
          this.brands = collection.results;
          this.resultsLength = collection.total;
        },
        complete: () => {
          this.isLoadingResults = false;
          this.apiCall$?.unsubscribe();
        }
    });
  }
    
  onLazyLoad(event: TableLazyLoadEvent) {
    this.pageSize = event.rows as number;
    this.pageIndex = event.first as number / this.pageSize;
    this.sort = { field: event.sortField as string, order: event.sortOrder as number };
    if (event.filters) {
      this.filters = {};
      for (const [key, value] of Object.entries(event.filters)) {
        const filter = value as FilterMetadata;
        if (filter.value) {
          this.filters[key] = filter.value;
        }
      }
    }
    this.getTableEntries();
  }
}
